import { render } from "./FrLinks.vue?vue&type=template&id=6679141c"
import script from "./FrLinks.vue?vue&type=script&lang=js"
export * from "./FrLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__